import React from "react"
import { Link } from "gatsby"
import Image from "gatsby-image"
import styles from "./arrayArticles.module.scss"

const ArrayArticles = ({ posts, className }) => {

  return (
    <section className={`${className} ${styles.container}`}>
      {posts.edges.map(({ node }) => {
        const title = node.frontmatter.title || node.fields.slug
        return (
          <article key={node.fields.slug} className="relative md:static my-4 block md:flex">
            <Image fluid={node.frontmatter.featuredImage.childImageSharp.fluid} className="object-cover md:object-none h-40 md:h-24 md:w-32 md:min-w-32 w-full"/>
            <header className="absolute md:static inset-x-0 bottom-0 bg-semiblack md:bg-transparent flex flex-col justify-around">
              <h3 className="px-3 pt-1 md:pt-0">
                <Link className="" to={node.fields.slug}>
                  <span className="text-prilight md:text-primary underline uppercase font-bold text-xl ">{title}</span> <span className="font-sans text-white md:text-black">Le <span className="italic font-semibold">{node.frontmatter.date}</span></span>
                </Link>
              </h3>
              <p className="text-white h-12 max-h-12 m-0 overflow-hidden px-3 pb-1 md:pb-0 leading-snug break-words md:text-black">{node.excerpt}</p>
            </header>
          </article>
        )
      })}
    </section>
  )
}

export default ArrayArticles